import { render, staticRenderFns } from "./publisher.vue?vue&type=template&id=00c01ae2&"
import script from "./publisher.vue?vue&type=script&lang=js&"
export * from "./publisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "publisher.vue"
export default component.exports